import React from 'react';
import { ArrowLeft, QrCode } from 'lucide-react';
import ModuleBarcode from './ModuleBarcode';
import { trainingModules } from '../data/trainingData';

const BarcodeTestPage = ({ onBack }) => {
  return (
    <div className="container">
      <div className="barcode-test-header">
        <button onClick={onBack} className="btn btn-secondary">
          <ArrowLeft size={16} style={{ marginRight: '8px' }} />
          Back to Admin
        </button>
        
        <div className="test-title">
          <QrCode size={32} />
          <h1>Barcode System Test</h1>
        </div>
        <p className="test-description">
          This page demonstrates the barcode system. Each module has a unique QR code that 
          redirects users to the login page with a module parameter, then to the specific module.
        </p>
      </div>

      <div className="test-instructions">
        <h2>How to Test:</h2>
        <ol>
          <li>Generate a QR code for any module below</li>
          <li>Scan the QR code with your phone's camera or QR code scanner</li>
          <li>You'll be redirected to the login page with a module-specific URL</li>
          <li>After logging in, you'll be taken directly to that training module</li>
        </ol>
      </div>

      <div className="test-modules">
        <h2>Available Modules for Testing:</h2>
        <div className="modules-grid">
          {trainingModules.slice(0, 3).map((module) => (
            <div key={module.id} className="test-module-card">
              <div className="module-header">
                <div className="module-icon">
                  {module.icon}
                </div>
                <div className="module-info">
                  <h3>{module.title}</h3>
                  <p>{module.description}</p>
                </div>
              </div>
              
              <div className="module-barcode">
                <ModuleBarcode 
                  moduleId={module.id} 
                  moduleTitle={module.title}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="test-urls">
        <h2>Direct Test URLs:</h2>
        <p>You can also test by visiting these URLs directly:</p>
        <div className="url-list">
          {trainingModules.slice(0, 3).map((module) => (
            <div key={module.id} className="url-item">
              <strong>{module.title}:</strong>
              <code>{window.location.origin}/login?module={module.id}</code>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BarcodeTestPage;
